export default __webpack_public_path__ + "static/media/Oscer-Terms&Conditions.d3e467f4.pdf";